import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { startTour } from "@/lib/tour";

export function TourButton({ testId }) {
  return (
    <Button variant="outline" onClick={startTour} data-testid={testId}>
      <Compass className="h-4 w-4 mr-1" />Ver tour
    </Button>
  );
}
